module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("99Iwo"))).then(() => parcelRequire('1iHdE'));